import React from 'react';
import './SalesmanAvatar.css';
import { useProtectedFileUrl } from '../../utils/protectedFiles';

// Helper to get initials from name
const getInitials = (name) => {
    if (!name) return '?';
    const parts = name.trim().split(' ');
    if (parts.length >= 2) {
        return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
};

const SalesmanAvatar = ({ 
    photo, 
    name, 
    size = 40, 
    rank = null,
    className = '' 
}) => {
    const rankClass = rank && rank <= 3 ? `rank-${rank}` : '';
    const { objectUrl: photoUrl } = useProtectedFileUrl(photo);
    
    return (
        <div className={`salesman-avatar-wrap ${rankClass} ${className}`}>
            {photo && photoUrl ? (
                <img 
                    src={photoUrl} 
                    alt={name}
                    className="salesman-avatar-img"
                    style={{ width: size, height: size }}
                    onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.nextSibling.style.display = 'flex';
                    }}
                />
            ) : null}
            <div 
                className="salesman-avatar-placeholder" 
                style={{ 
                    display: photo && photoUrl ? 'none' : 'flex',
                    width: size,
                    height: size,
                    fontSize: size * 0.35
                }}
            >
                {getInitials(name)}
            </div>
        </div>
    );
};

export default SalesmanAvatar;
